import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { MaintenanceWindowsEvents } from '../../../configurationProfilesApp/maintenanceWindowGrid/types';

export class MaintenanceWindowsSideNavWebComponent extends LitElement {
  // see https://lit-element.polymer-project.org/guide/properties
  @property({ type: String, reflect: true })
  label = '';

  @property({ type: String, reflect: true })
  activeButton = 'all';

  @property({ type: String, reflect: true })
  allPatches = '';

  @property({ type: String, reflect: true })
  securityPatches = '';

  @property({ type: String, reflect: true })
  nonSecurityPatches = '';

  @property({ type: String, reflect: true })
  manuallyApprovedPatches = '';

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div class="maintenance-windows-sidenav">
        <div class="maintenance-windows-sidenav--body">
          <gz-title class="title" fontweight="600" fontsize="11">${this.label}</gz-title>
          <gz-list-item @click="${this.showAllPatches}" .active="${this.isButtonActive('all')}">
            ${this.allPatches}
          </gz-list-item>
          <gz-list-item @click="${this.showSecurityPatches}" .active="${this.isButtonActive('security')}">
            ${this.securityPatches}
          </gz-list-item>
          <gz-list-item @click="${this.showNonSecurityPatches}" .active="${this.isButtonActive('non-security')}">
            ${this.nonSecurityPatches}
          </gz-list-item>
          <gz-list-item
            @click="${this.showManuallyApprovedPatches}"
            .active="${this.isButtonActive('manually-approved')}"
          >
            ${this.manuallyApprovedPatches}
          </gz-list-item>
        </div>
      </div>
    `;
  }

  isButtonActive(button: string) {
    return this.activeButton === button;
  }

  constructor() {
    super();
  }

  showAllPatches() {
    this.activeButton = 'all';

    this.dispatchEvent(
      new CustomEvent(MaintenanceWindowsEvents.SHOW_ALL_PATCHES, {
        detail: {},
        bubbles: true,
        composed: true,
      })
    );
  }

  showSecurityPatches() {
    this.activeButton = 'security';

    this.dispatchEvent(
      new CustomEvent(MaintenanceWindowsEvents.SHOW_SECURITY_PATCHES, {
        detail: {},
        bubbles: true,
        composed: true,
      })
    );
  }

  showNonSecurityPatches() {
    this.activeButton = 'non-security';

    this.dispatchEvent(
      new CustomEvent(MaintenanceWindowsEvents.SHOW_NON_SECURITY_PATCHES, {
        detail: {},
        bubbles: true,
        composed: true,
      })
    );
  }

  showManuallyApprovedPatches() {
    this.activeButton = 'manually-approved';

    this.dispatchEvent(
      new CustomEvent(MaintenanceWindowsEvents.SHOW_MANUALLY_APPROVED_PATCHES, {
        detail: {},
        bubbles: true,
        composed: true,
      })
    );
  }
}
